"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useDebug = useDebug;
var _react = require("react");
/* eslint-disable no-console -- it is the point of this helper */ function getTime() {
    var date = new Date();
    var minutes = "0".concat(date.getMinutes());
    var seconds = "0".concat(date.getSeconds());
    var milliseconds = "00".concat(date.getMilliseconds());
    var LAST_TWO_DIGITS = -2;
    var LAST_THREE_DIGITS = -3;
    return "".concat(date.getHours(), ":").concat(minutes.slice(LAST_TWO_DIGITS), ":").concat(seconds.slice(LAST_TWO_DIGITS), ".").concat(milliseconds.slice(LAST_THREE_DIGITS));
}
function isDebugEnabled() {
    try {
        var serializedData = localStorage.getItem('ori-ui-quantity-picker-debug');
        if (serializedData) {
            var value = JSON.parse(serializedData);
            return value === 4;
        }
        return false;
    } catch (error) {
        return false;
    }
}
function useDebug(key) {
    var isEnabled = isDebugEnabled();
    var log = (0, _react.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _console;
        if (!isEnabled) {
            return;
        }
        (_console = console).log.apply(_console, [
            "%c\uD83D\uDD36 ".concat(getTime(), " ").concat(key),
            'color:#FFA07A;background:#1c1c1c;'
        ].concat(_to_consumable_array(args)));
    }, [
        isEnabled,
        key
    ]);
    return {
        log: log
    };
} //# sourceMappingURL=useDebug.js.map
